import React from "react"

import "./our-portfolio.css"

const PortfolioHeroSection = () => {
  return (
    <section id="our-portfolio-hero">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title">
              <h1>Portfolio</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PortfolioHeroSection
